exports.components = {
  "component---src-templates-intake-js": () => import("./../../../src/templates/intake.js" /* webpackChunkName: "component---src-templates-intake-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

